module.exports = __webpack_public_path__ + "static/media/logo.f1d71148.png";